export default __webpack_public_path__ + "static/media/fire-protection.0504b43b.jpg";